import {
  IEsgFilters,
  IinitialStateServerEsg,
} from "../pages/Esg/EsgDashboard.type";

const getEsgFilteredData = (
  dataServer: IinitialStateServerEsg,
  filters: IEsgFilters
) => {
  if (dataServer.projects && filters.parametr_esg.id !== "") {
    const topNumber = () => {
      if (filters.value_esg.id === "" || filters.value_esg.id === "top25")
        return 25;
      if (filters.value_esg.id === "top50") return 50;
      if (filters.value_esg.id === "top100") return 100;
    };
    let sortedProjects = dataServer.projects;
    if (filters.parametr_esg.id === "cagr_tier") {
      sortedProjects = [...dataServer.projects].sort((a, b) =>
        a.cagr_tier > b.cagr_tier ? 1 : -1
      );
    } else if (filters.parametr_esg.id === "rank_tier") {
      sortedProjects = [...dataServer.projects].sort((a, b) =>
        a.rank_tier > b.rank_tier ? 1 : -1
      );
    } else if (
      filters.parametr_esg.id === "global_market_forecast_2030_bln_usd"
    ) {
      sortedProjects = [...dataServer.projects].sort((a, b) =>
        a.market_forecast_tier > b.market_forecast_tier ? 1 : -1
      );
    }

    const filteredProjects = sortedProjects.slice(0, topNumber());
    const newObject = {...dataServer, projects: filteredProjects};
    return newObject;
  } else return dataServer;
};

export default getEsgFilteredData;
